module.exports = __webpack_public_path__ + "img/profile-tori.9ab4ba4c.webp";